module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-catch-links@5.15.0_gatsby@5.15.0_babel-eslint@10.1.0_eslint@7.32.0__react-dom@1_ngl2hakndsw2mhuvnhrcsuj5k4/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_eslint@7.32.0__react-dom@18.3.1_react@18.3.1__react@18.3.1__5rucmuyckc2g5tqpkega6muzpq/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
